import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { resetLayout } from 'core/templates/actions'
import { setConfiguration, resetConfiguration } from './actions'
import { setPointOfSales, resetTradeIn } from '../trade-in/actions'

import { getLang } from '../core/utils/actions/intl'
import Configuration from './Configuration'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configuration: state.configuration,
  tradeIn: state.tradeIn
})

const mapDispatchToProps = {
  setWizards,
  setConfiguration,
  setPointOfSales,
  resetConfiguration,
  resetTradeIn,
  getLang,
  resetLayout
}

export default connect(mapStateToProps, mapDispatchToProps)(Configuration)
